import { isValidSelector } from 'anodum';
import { connectedStore } from '../../store';
import getConstraints from '../selectors/constraints';

const findAllFor = (element) => {
  const store = connectedStore.get();
  const state = store.getState();
  const constraints = getConstraints(state);

  return constraints.filter((constraint) => {
    if (!isValidSelector(constraint.element)) return false;
    return element.matches(constraint.element);
  });
};

export default findAllFor;
